<template>
    <div class="echarts-horizontal-bar-wrapper" :style="{ height: height + 'px' }">
        <v-chart :options="chartOptions" autoresize ref="chart" />
    </div>
</template>
<script>
export default {
    name: "EChartsHorizontalBar",
    props: {
        labels: { type: Array, default: () => [] },
        datasets: { type: Array, default: () => [] },
        options: { type: Object, default: () => ({}) },
        height: { type: Number, default: 300 },
    },
    computed: {
        chartOptions() {
            const series = this.datasets.map((ds) => {
                const hasPerItemColors = Array.isArray(ds.backgroundColor);
                return {
                    name: ds.label || "",
                    type: "bar",
                    data: hasPerItemColors
                        ? (ds.data || []).map((val, i) => ({
                              value: val,
                              itemStyle: {
                                  color: ds.backgroundColor[i] || "#3b82f6",
                              },
                          }))
                        : ds.data || [],
                    barMaxWidth: 30,
                    itemStyle: hasPerItemColors
                        ? { borderRadius: [0, 3, 3, 0] }
                        : {
                              color: ds.backgroundColor || "#3b82f6",
                              borderRadius: [0, 3, 3, 0],
                          },
                };
            });

            return {
                tooltip: {
                    trigger: "axis",
                    axisPointer: { type: "shadow" },
                    backgroundColor: "rgba(0,0,0,0.8)",
                    textStyle: { color: "#fff", fontSize: 12 },
                    padding: 12,
                    borderRadius: 8,
                },
                legend: {
                    top: 0,
                    textStyle: { fontSize: 12 },
                    data: this.datasets.map((ds) => ds.label || ""),
                },
                grid: {
                    left: "3%",
                    right: "4%",
                    bottom: "3%",
                    containLabel: true,
                },
                xAxis: {
                    type: "value",
                    axisLine: { show: false },
                    splitLine: { lineStyle: { color: "rgba(0,0,0,0.06)" } },
                    axisLabel: { fontSize: 11, color: "#6b7280" },
                },
                yAxis: {
                    type: "category",
                    data: this.labels,
                    axisLine: { lineStyle: { color: "#e5e7eb" } },
                    axisLabel: { fontSize: 11, color: "#6b7280" },
                    inverse: true,
                },
                series,
                ...this.options,
            };
        },
    },
};
</script>
<style scoped>
.echarts-horizontal-bar-wrapper {
    position: relative;
    width: 100%;
}
.echarts-horizontal-bar-wrapper .echarts {
    width: 100% !important;
    height: 100% !important;
}
</style>
